/* Shopify cart helpers shared by the ported product templates. */
(function () {
  'use strict';

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + n;
  }

  function refreshCount() {
    return fetch(window.CS.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  /**
   * Add one or more lines to the cart.
   * @param {Array<{id:number, quantity:number, properties?:Object}>} items
   * @returns {Promise<Object>} resolves with the updated cart
   */
  function add(items) {
    return fetch(window.CS.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(refreshCount);
  }

  window.CSCart = { add: add, refreshCount: refreshCount, money: money };
})();
